<template>
    <el-row :gutter="gutter">
        <el-col v-for="(item, index) in newAudio" :key="rowKey ? item[rowKey] : index"
            :span="setSpan ? setSpan(item, index) : span">
            <slot :row="item" :index="index" :disabled="setDisabled(item)" />
        </el-col>
    </el-row>
</template>
  
<script>
export default {
    name: 'BaseAudioGrid',

    props: {
        audios: {
            type: Array,
            default: () => []
        },
        gutter: {
            type: Number,
            default: 20
        },
        span: {
            type: Number,
            default: 6
        },
        rowKey: String,
        srcKey: String,
        exclude: {
            type: Array,
            default: () => ['no_photo']
        },
        setSpan: Function,
        url: [String, Function]
    },
    data() {
        return {
            newAudio: []
        }
    },

    computed: {
    },

    watch: {
        audios(val) {
            this.newAudio= []
            this.$nextTick(() => {
                this.newAudio = val
            })
        }
    },
    methods: {
        setDisabled(row) {
            if (this.srcKey && row) {
                const src = row[this.srcKey]
                return !src || this.exclude.some(k => src.indexOf(k) > -1)
            }
            return false
        }
    }
}
</script>
<style lang="scss" scoped>
.el-message-box{
    display: inline-block;
    //width: 5.6rem;
    padding-bottom: 0.13333rem;
    vertical-align: middle;
    background-color: #FFF;
    border-radius: 0.05333rem;
    border: 1px solid #EBEEF5;
    font-size: 0.24rem;
    -webkit-box-shadow: 0 2px 0.16rem 0 rgba(0,0,0,.1);
    box-shadow: 0 2px 0.16rem 0 rgba(0,0,0,.1);
    text-align: left;
    -webkit-backface-visibility: hidden;
    backface-visibility: hidden;
}
</style>